
import React from 'react';
import { Image, Code, Brush } from 'lucide-react';
import { ContentType } from '@/utils/chatContentUtils';

interface ChatContentTypeBadgeProps {
  contentType: ContentType;
}

const ChatContentTypeBadge = ({ contentType }: ChatContentTypeBadgeProps) => {
  if (contentType === 'text') return null;
  
  switch(contentType) {
    case 'image':
      return (
        <div className="absolute top-11 right-3 bg-[#1A1F2C] text-white px-2 py-0.5 rounded-full text-xs flex items-center">
          <Image className="h-3 w-3 mr-1" />
          Image
        </div>
      );
    case 'canvas':
      return (
        <div className="absolute top-11 right-3 bg-purple-500/90 text-white px-2 py-0.5 rounded-full text-xs flex items-center">
          <Brush className="h-3 w-3 mr-1" />
          Canvas
        </div>
      );
    case 'code':
      return (
        <div className="absolute top-11 right-3 bg-green-500/90 text-white px-2 py-0.5 rounded-full text-xs flex items-center">
          <Code className="h-3 w-3 mr-1" />
          Code
        </div>
      );
    default:
      return null;
  }
};

export default ChatContentTypeBadge;
